







































import { Voucher } from '@ssp/inscreva-sse-models';
import SortTable, { SortBy } from '@ssp/ss-commons-front/src/components/SortTable.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    SortTable,
  },
})
export default class VoucherListComponent extends Vue {
  @Prop({ required: true })
  private vouchers!: Array<Voucher>;

  @Prop({ required: true })
  private sortBy!: SortBy<Voucher>;

  private headers: any[] = [
    { text: '#', sortable: false },
    { text: 'Nome', value: 'voucher.extraInfo?.nome' },
    { text: 'Código', value: 'voucher.code' },
    { text: 'Data', value: 'voucher.createdAt' },
    { text: 'Lido', value: 'voucher.activated' },
    { text: '', sortable: false },
  ];

  private sortList(sortBy: any) {
    this.$emit('sort-list', sortBy);
  }

  private onActivate(voucher: Voucher) {
    return this.$emit('on-activate', voucher);
  }
}
